var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-vh-100",attrs:{"id":"app"}},[_c('router-view'),_c('notifications',{attrs:{"group":"generic","position":"bottom","width":"100%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }